import {BaseModel} from '@shared/models/worksheet/BaseModel';
import { MaterialTestValue } from './material-test-value.model';

export class MaterialSample extends BaseModel {
  dryMatterRange = 0;
  dryMatterLow = 0;
  dryMatterHigh = 18;
  nutrientValueSource = 1;
  nutrientValueBasis = 0;
  materialTestValues: MaterialTestValue[] = [];

  constructor(init?: Partial<any>) {
    super();
    Object.assign(this, init);
    const defaultMaterialValues = [];
    defaultMaterialValues[0] = new MaterialTestValue('DM', 0.00);
    defaultMaterialValues[1] = new MaterialTestValue('P', 0.12);

    if (init){
      this.materialTestValues = defaultMaterialValues.map(d => init.materialTestValues?.find(i => i.testCode === d.testCode) ?? d);
    }else{
      this.materialTestValues = defaultMaterialValues;
    } 
  }
}
